module.exports = __webpack_public_path__ + "media/img/frontend_application/banner-sgbrideonthehunt-ipad-ed569bdd97f232e8d859af18fe7ee8e6.png";